import { MutationTree, Payload } from 'vuex';
import { WorkBook } from 'xlsx';
import { BulkState, StationAdjustmentXlsx } from './types';

export class ImportStationAdjustmentXlsxMutation implements Payload {
    public readonly type = 'importStationAdjustmentXlsx';
    public readonly stationAdjustmentXlsx: StationAdjustmentXlsx[] | null;
    public readonly fileName: string;
    constructor(stationAdjustmentXlsx: StationAdjustmentXlsx[] | null, fileName: string) {
        this.stationAdjustmentXlsx = stationAdjustmentXlsx;
        this.fileName = fileName;
    }
}

export class ImportLayoutLayfMutation implements Payload {
    public readonly type = 'importLayoutLayf';
    public readonly layoutLayf: any;
    public readonly fileName: string;
    constructor(layoutLayf: any, fileName: string) {
        this.layoutLayf = layoutLayf;
        this.fileName = fileName;
    }
}

export const mutations: MutationTree<BulkState> = {
    importStationAdjustmentXlsx(state, mutation: ImportStationAdjustmentXlsxMutation) {
        state.stationAdjustmentData.stationAdjustmentXlsx = mutation.stationAdjustmentXlsx;
        state.stationAdjustmentData.stationAdjustmentXlsxName = mutation.fileName;
    },
    importLayoutLayf(state, mutation: ImportLayoutLayfMutation) {
        state.stationAdjustmentData.layoutLayf = mutation.layoutLayf;
        state.stationAdjustmentData.layoutLayfName = mutation.fileName;
    },
};
